// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const tilaratkaisu = {
  seoMetaTags: {
    tags: [
      {
        tagName: "title",
        content: "Laske sopiva tilaratkaisu | Ester1",
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:title",
          content: "Laske sopiva tilaratkaisu",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:title",
          content: "Laske sopiva tilaratkaisu",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "description",
          content: "Suunnittelemme yrityksellenne toimivan ja  tehokkaan tilaratkaisun, joka vastaa nykyaikaisen yrityskulttuurin tapoihin. Moderni toimisto on enemmän kuin joukko työpisteitä. Se on luova ja inspiroiva tila, jossa ihmiset viihtyvät ja työnteko sujuu mutkattomasti.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:description",
          content: "Suunnittelemme yrityksellenne toimivan ja  tehokkaan tilaratkaisun, joka vastaa nykyaikaisen yrityskulttuurin tapoihin. Moderni toimisto on enemmän kuin joukko työpisteitä. Se on luova ja inspiroiva tila, jossa ihmiset viihtyvät ja työnteko sujuu mutkattomasti.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:description",
          content: "Suunnittelemme yrityksellenne toimivan ja  tehokkaan tilaratkaisun, joka vastaa nykyaikaisen yrityskulttuurin tapoihin. Moderni toimisto on enemmän kuin joukko työpisteitä. Se on luova ja inspiroiva tila, jossa ihmiset viihtyvät ja työnteko sujuu mutkattomasti.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:card",
          content: "summary",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:modified_time",
          content: "2022-05-30T08:46:13Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:published_time",
          content: "2019-11-09T10:50:44Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:locale",
          content: "fi_FI",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:type",
          content: "article",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:site_name",
          content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:image",
          content: "/content-images/1655981672-yleiset-tilat-10-web.jpg",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:image",
          content: "/content-images/1655981672-yleiset-tilat-10-web.jpg",
        },
      },
    ],
  },
  content: "<p>Tiimiss&auml; ty&ouml;skentely, et&auml;ty&ouml;, puhelinpalaverit ja asiakastapaamiset &ndash; mit&auml; kaikkea yrityksenne arki sis&auml;lt&auml;&auml;? Optimaalisen tilaratkaisun aikaansaamiseksi huomioimme yrityksenne toimintatavat yksityiskohtaisesti.</p><p>Ester1ss&auml; ei ole aulapalvelua tai suuria konferenssitiloja, mik&auml; tekee siit&auml; my&ouml;s kustannustehokkaan vaihtoehdon. T&auml;st&auml; huolimatta lupaamme ripe&auml;&auml; ja henkil&ouml;kohtaista palvelua kaikille talon k&auml;ytt&auml;jille sek&auml; l&auml;pin&auml;kyv&auml;n hinnoittelun.</p>",
  heroLayer: {
    alpha: 26,
    blue: 38,
    green: 24,
    red: 0,
  },
  imgHero: asset("1655981672-yleiset-tilat-10-web.jpg", {
    sizes: "(max-width: 1600px) 100vw, 1600px",
    aspectRatio: 1.777344,
  }),
  kerrospohjatH: "Kerrospohjat",
  laskeHinta: "Tilaratkaisu 48 tunnissa",
  laskeHintaTeksti: "Laske hinta-arvio ja jätä tietosi. Saat alustavan tilaehdotuksen heti sähköpostiisi. Otamme yhteyttä ensi tilassa ja kartoitamme tarpeenne tarkemmin. Tämän jälkeen saat tarjouksen 2 työpäivän sisällä. Jos tarvitsette tilat yli 100 hengelle tai useamman kerroksen käyttöönne, ole suoraan yhteydessä myyntiimme.",
  pyydaTarjousTeksti: "Oletko kiinnostunut suuremmasta tai useamman kerroksen tilaratkaisusta? Ota yhteyttä.",
  lead: "Suunnittelemme yrityksellenne toimivan ja  tehokkaan tilaratkaisun, joka vastaa nykyaikaisen yrityskulttuurin tapoihin. Moderni toimisto on enemmän kuin joukko työpisteitä. Se on luova ja inspiroiva tila, jossa ihmiset viihtyvät ja työnteko sujuu mutkattomasti.",
  laskehintaAlateksti: "Hinta-arvio sisältää mahdollisesti valitut autopaikkavuokrat. Pohjakuva ja ratkaisu suuntaa-antava. Ota yhteyttä, niin asiantuntijamme ehdottaa juuri teidän tarpeisiinne soveltuvan ratkaisun.",
  otaYhteyttaAlateksti: "<p>Kysytt&auml;v&auml;&auml;? Soita <a href=\"tel:0108368424\">010 8368 424</a></p>",
  otaYhteyttaTeksti: "Jätä tietosi ja lähetämme alustavan tilaehdotuksen ja hinta-arvion heti sähköpostiisi.",
  autopaikanHinta: 195,
  ryhdyToimeen: "Ryhdy toimeen",
  ryhdyToimeenTeksti: "Suunnittelemme yrityksenne toimintaan ja tulevaisuuden näkymiin sopivan tilaratkaisun, jossa neliöt laitetaan hyötykäyttöön ja arki luistaa. ",
  tilaratkaisuList1: "Arvioi tilatarpeesi, valitse sisustustyyli ja laske alustava hinta-arvio.",
  tilaratkaisuList2: "Otamme yhteyttä ensi tilassa ja kartoitamme tarpeenne.",
  tilaratkaisuList3: "Saatte tarjouksen kahden työpäivän kuluessa kartoituksesta.",
  tilaratkaisuList4: "Olette valmiita muuttamaan uusiin toimistotiloihin Pasilan sydämeen.",
  title: "Tilaratkaisu",
  valahdyksiaH: "Välähdyksiä Ester1stä",
};

module.exports = { tilaratkaisu };
